import { getInclusionOptions } from '../logicHelpers'
import { getIntegrationData } from '@dashboard/modules/integration/services/integrationDataUtilities'

const wordpressSource = () => ({
  types: [
    { label: 'Current page', value: 'current-pageId', description: "The WordPress page they're on" },
    { label: 'Current post', value: 'current-postId', description: "The WordPress post they're reading" },
    { label: "Current post's tags", value: 'current-taxonomy-post_tag', description: 'Tags on the post' },
    { label: "Current post's category", value: 'current-taxonomy-category', description: "The post's category" },
    { label: 'Favorite tag', value: 'favorite-taxonomy-post_tag', description: 'The tag they read most' },
    { label: 'Favorite category', value: 'favorite-taxonomy-category', description: 'The category they read most' }
  ],
  inputs: [
    {
      control: 'select',
      key: 'operator-select',
      name: 'operator',
      options: getInclusionOptions(),
      can: (condition: { $source: string }) => condition.$source === 'wordpress'
    },
    {
      control: 'autocomplete',
      key: 'value-select-page',
      name: 'value',
      options: async () => {
        const data = await getIntegrationData('wordpress', 'pages')
        return data.value.map((page) => ({
          label: page.caption,
          value: String(page.id)
        }))
      },
      multiple: true,
      can: (condition: { $source: string; operator: string; $type: string }) =>
        condition.$source === 'wordpress' && condition.$type === 'current-pageId'
    },
    {
      control: 'autocomplete',
      key: 'value-select-post',
      name: 'value',
      options: async () => {
        const data = await getIntegrationData('wordpress', 'posts')
        return data.value.map((page) => ({
          label: page.caption,
          value: String(page.id)
        }))
      },
      multiple: true,
      can: (condition: { $source: string; operator: string; $type: string }) =>
        condition.$source === 'wordpress' && condition.$type === 'current-postId'
    },
    {
      control: 'autocomplete',
      key: 'value-select-post-tags',
      name: 'value',
      options: async () => {
        const data = await getIntegrationData('wordpress', 'taxonomies')
        const tags = data.value.find((tax) => tax.id === 'post_tag')?.terms || []
        return tags.map((page) => ({
          label: page.caption,
          value: String(page.id)
        }))
      },
      multiple: true,
      can: (condition: { $source: string; operator: string; $type: string }) =>
        condition.$source === 'wordpress' && condition.$type === 'current-taxonomy-post_tag'
    },
    {
      control: 'autocomplete',
      key: 'value-select-categories',
      name: 'value',
      options: async () => {
        const data = await getIntegrationData('wordpress', 'taxonomies')
        const categories = data.value.find((tax) => tax.id === 'category')?.terms || []
        return categories.map((page) => ({
          label: page.caption,
          value: String(page.id)
        }))
      },
      multiple: true,
      can: (condition: { $source: string; operator: string; $type: string }) =>
        condition.$source === 'wordpress' && condition.$type === 'current-taxonomy-category'
    },
    {
      control: 'autocomplete',
      key: 'value-select-favorite-tags',
      name: 'value',
      options: async () => {
        const data = await getIntegrationData('wordpress', 'taxonomies')
        const tags = data.value.find((tax) => tax.id === 'post_tag')?.terms || []
        return tags.map((page) => ({
          label: page.caption,
          value: String(page.id)
        }))
      },
      multiple: true,
      can: (condition: { $source: string; operator: string; $type: string }) =>
        condition.$source === 'wordpress' && condition.$type === 'favorite-taxonomy-post_tag'
    },
    {
      control: 'autocomplete',
      key: 'value-favorite-categories',
      name: 'value',
      options: async () => {
        const data = await getIntegrationData('wordpress', 'taxonomies')
        const categories = data.value.find((tax) => tax.id === 'category')?.terms || []
        return categories.map((page) => ({
          label: page.caption,
          value: String(page.id)
        }))
      },
      multiple: true,
      can: (condition: { $source: string; operator: string; $type: string }) =>
        condition.$source === 'wordpress' && condition.$type === 'favorite-taxonomy-category'
    }
  ]
})

export default wordpressSource
